import styled from "styled-components";

interface FieldContainerProps {
  hasHiddenField: boolean;
  colStart?: number;
  colEnd?: number;
  rowStart?: number;
  rowEnd?: number;
  span?: number;
}

interface SectionFieldsContainerProps {
  isOpened: boolean;
  className?: string;
  index?: number;
}

interface IAccordionIconProps {
  isOpen: boolean;
}

interface IFormGroupProps {
  hasSpanTwoFields: boolean;
}

export const SectionFieldsContainer = styled.div.attrs<SectionFieldsContainerProps>(
  {
    className: "grid grid-cols-1 md:grid-cols-2 gap-4",
  }
)<SectionFieldsContainerProps>`
  overflow-y: hidden;
  max-height: 0;
  transform-origin: top;
  transition:
    transform 0.25s ease-in-out,
    max-height 0.25s ease-in-out;
  transform: scaleY(0);
  &.open {
    max-height: 100%;
    transform: scaleY(1);
    overflow: visible;
    z-index: ${({ index }) => 1000 + (index ?? 0)};
    position: relative;
  }
`;

export const AccordionIcon = styled.img.attrs({
  className: `h-7 w-7 cursor-pointer`,
})<IAccordionIconProps>`
  transition: all 0.25s ease-in-out;
  transform: ${({ isOpen }) => (!isOpen ? "rotate(-90deg)" : "")};
`;

export const FormGroupContainer = styled.div.attrs({
  className: "",
})<IFormGroupProps>`
  grid-column: span 2 / span 2;
  @media screen and (min-width: 768px) {
    grid-column: ${(props) =>
      props.hasSpanTwoFields ? "span 2 / span 2" : "span 1 / span 1"};
  }
`;

export const HiddenField = styled.div.attrs({
  className: "hidden",
})``;

export const FieldContainer = styled.div.attrs({
  className: "",
})<FieldContainerProps>`
  ${(props) =>
    props.hasHiddenField &&
    `
    display: none;
  `};
`;

export const ActionBtnsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: red;
`;
export const IncidentFormActionsBtnsContainer = styled.div`
  /* border: 1px solid green; */
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
  @media screen and (min-width: 1025px) {
    width: 0%;
    width: 36%;
  }
  @media screen and (max-width: 425px) {
    width: 100%;
  }
  @media screen and (max-width: 320px) {
    flex-direction: column;
    align-items: center;
  }
`;
